// Retorna uma string com o tipo de dispositivo utilizado a depender do width da tela
export default function checkDeviceType() {
    let windowWidth = window.innerWidth;

    if (windowWidth < 768) return 'phone'
    else if (windowWidth < 1024) return 'tablet'
    else return 'desktop'
}